import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';

export type CampaignTrialMetricType = 'promoCampaign' | 'trialLinkTrial';

/** Matches Mongo projection from GET .../campaignsAndTrialsNamesAndIds */
export interface CampaignsAndTrialsNamesAndIdsRow {
    _id: string;
    type: CampaignTrialMetricType;
    foreignId: number;
    payload: {
        name?: string;
        createdAt?: Date;
        campaignCode?: number;
        url?: string;
    };
}

const useCampaignsAndTrialsTrackingMetrics = (enabled: boolean) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const params = useParams();
    const axios = useAxios();

    const userId = 'userId' in params ? params.userId : undefined;

    return useQuery(
        ['campaignsAndTrialsNamesAndIds', userId],
        async (): Promise<CampaignsAndTrialsNamesAndIdsRow[]> => {
            const query = `${settingsContext.routes.metrics.base}${userId}/campaignsAndTrialsNamesAndIds`;
            const { data } = await axios.get<CampaignsAndTrialsNamesAndIdsRow[]>(query);
            if (!Array.isArray(data)) {
                return [];
            }
            return data.map(row => ({
                ...row,
                _id: String(row._id),
            }));
        },
        {
            enabled: Boolean(enabled && userContext.jwtToken && settingsContext.apiKey && userId),
            staleTime: 60 * 1000,
        },
    );
};

export default useCampaignsAndTrialsTrackingMetrics;
